

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "re-formality/src/Formality.bs.js";
import * as Json_decode from "@glennsl/bs-json/src/Json_decode.bs.js";
import * as Async$RecountTools from "../../util/Async.bs.js";
import * as Modal$RecountTools from "../../components/Modal.bs.js";
import * as Layout$RecountTools from "../../layout/Layout.bs.js";
import * as Request$RecountTools from "../../util/Request.bs.js";
import * as Formality__ReactUpdate from "re-formality/src/Formality__ReactUpdate.bs.js";
import * as Form_Input$RecountTools from "../../components/Form/Form_Input.bs.js";
import * as Form_Button$RecountTools from "../../components/Form/Form_Button.bs.js";
import * as SectionStore$RecountTools from "../../stores/SectionStore.bs.js";
import * as ToastProvider$RecountTools from "../../components/ToastProvider.bs.js";
import * as Models_Section$RecountTools from "../../models/Models_Section.bs.js";

var validators_slug = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (input) {
      var match = input.slug;
      if (match === "") {
        return {
                TAG: /* Error */1,
                _0: "Show is required"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: input.slug
              };
      }
    })
};

var validators_sectionTitle = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (input) {
      var match = input.sectionTitle;
      if (match === "") {
        return {
                TAG: /* Error */1,
                _0: "Title is required"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: input.sectionTitle
              };
      }
    })
};

var validators = {
  slug: validators_slug,
  sectionTitle: validators_sectionTitle
};

function initialFieldsStatuses(_input) {
  return {
          slug: /* Pristine */0,
          sectionTitle: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            slug: /* Pristine */0,
            sectionTitle: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.slug;
  var match_0 = match ? match._0 : Curry._1(validators.slug.validate, input);
  var match$1 = fieldsStatuses.sectionTitle;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.sectionTitle.validate, input);
  var slugResult = match_0;
  var slugResult$1;
  if (slugResult.TAG === /* Ok */0) {
    var sectionTitleResult = match_0$1;
    if (sectionTitleResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                sectionTitle: sectionTitleResult._0,
                slug: slugResult._0
              },
              fieldsStatuses: {
                slug: /* Dirty */{
                  _0: slugResult,
                  _1: /* Shown */0
                },
                sectionTitle: /* Dirty */{
                  _0: sectionTitleResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    slugResult$1 = slugResult;
  } else {
    slugResult$1 = slugResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            slug: /* Dirty */{
              _0: slugResult$1,
              _1: /* Shown */0
            },
            sectionTitle: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurSlugField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.slug, validators_slug, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  slug: status,
                                  sectionTitle: init.sectionTitle
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSectionTitleField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.sectionTitle, validators_sectionTitle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  slug: init.slug,
                                  sectionTitle: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateSlugField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.slug, state.submissionStatus, validators_slug, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            slug: status,
                                            sectionTitle: init.sectionTitle
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSectionTitleField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.sectionTitle, state.submissionStatus, validators_sectionTitle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            slug: init.slug,
                                            sectionTitle: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                slug: /* Pristine */0,
                                sectionTitle: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                slug: /* Pristine */0,
                                sectionTitle: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateSlug: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSlugField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSectionTitle: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSectionTitleField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurSlug: (function (param) {
              return Curry._1(dispatch, /* BlurSlugField */0);
            }),
          blurSectionTitle: (function (param) {
              return Curry._1(dispatch, /* BlurSectionTitleField */1);
            }),
          slugResult: Formality.exposeFieldResult(state.fieldsStatuses.slug),
          sectionTitleResult: Formality.exposeFieldResult(state.fieldsStatuses.sectionTitle),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.slug || match.sectionTitle) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var AddSectionForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function Page_Sections_AddForm(Props) {
  var isOpen = Props.isOpen;
  var onClose = Props.onClose;
  var match = ToastProvider$RecountTools.useToast(undefined);
  var makeToast = match[0];
  var form = useForm({
        sectionTitle: "",
        slug: ""
      }, (function (output, cb) {
          var body = Request$RecountTools.RequestBody.json({
                data: {
                  title: output.sectionTitle,
                  slug: output.slug
                }
              });
          Async$RecountTools.onFailure(Async$RecountTools.map(Async$RecountTools.map(Async$RecountTools.flatMap(Request$RecountTools.post(body, undefined, undefined, undefined, {
                                TAG: /* Api */0,
                                _0: "/v2/sections"
                              }), (function (prim) {
                              return prim.json();
                            })), (function (res) {
                          var section = Json_decode.field("data", Models_Section$RecountTools.fromJson, res);
                          SectionStore$RecountTools.add(section);
                          return section;
                        })), (function (param) {
                      Curry._1(onClose, undefined);
                      Curry._1(cb.reset, undefined);
                      Curry._3(makeToast, undefined, /* Confirm */1, "New Section saved");
                      
                    })), (function (param) {
                  Curry._3(makeToast, undefined, /* Error */2, "Unable to save Section");
                  return Curry._1(cb.notifyOnFailure, /* UnexpectedServerError */0);
                }));
          
        }));
  var slugify = function (str) {
    return str.replace(/^\s+|\s+$/g, "").toLowerCase().replace(/\s+/g, "-").replace(/-$/g, "");
  };
  var modalBody = React.createElement("form", {
        onSubmit: (function ($$event) {
            $$event.preventDefault();
            return Curry._1(form.submit, undefined);
          })
      }, React.createElement(Modal$RecountTools.Header.make, {
            children: "Add a Section"
          }), React.createElement(Modal$RecountTools.Body.make, {
            children: null
          }, React.createElement(Layout$RecountTools.Columns.make, {
                children: React.createElement(Layout$RecountTools.Columns.Column.make, {
                      children: React.createElement(Form_Input$RecountTools.make, {
                            value: form.input.sectionTitle,
                            label: "Section Title",
                            error: form.sectionTitleResult,
                            onChange: (function (e) {
                                if (slugify(form.input.sectionTitle) === form.input.slug) {
                                  Curry._2(form.updateSlug, (function (input, value) {
                                          return {
                                                  sectionTitle: input.sectionTitle,
                                                  slug: value
                                                };
                                        }), slugify(e.target.value));
                                }
                                return Curry._2(form.updateSectionTitle, (function (input, value) {
                                              return {
                                                      sectionTitle: value,
                                                      slug: input.slug
                                                    };
                                            }), e.target.value);
                              }),
                            onBlur: (function (param) {
                                return Curry._1(form.blurSectionTitle, undefined);
                              }),
                            disabled: form.submitting
                          })
                    })
              }), React.createElement(Layout$RecountTools.Columns.make, {
                children: React.createElement(Layout$RecountTools.Columns.Column.make, {
                      children: React.createElement(Form_Input$RecountTools.make, {
                            value: form.input.slug,
                            label: "Slug",
                            error: form.slugResult,
                            onChange: (function (e) {
                                return Curry._2(form.updateSlug, (function (input, value) {
                                              return {
                                                      sectionTitle: input.sectionTitle,
                                                      slug: value
                                                    };
                                            }), e.target.value.replace(/\s+/g, "-"));
                              }),
                            onBlur: (function (e) {
                                return Curry._1(form.blurSlug, undefined);
                              }),
                            disabled: form.submitting,
                            placeholder: "my-section-slug"
                          })
                    })
              })), React.createElement(Modal$RecountTools.Footer.make, {
            children: React.createElement("div", {
                  className: "field is-grouped"
                }, React.createElement(Form_Button$RecountTools.make, {
                      label: "Cancel",
                      disabled: form.submitting,
                      className: "is-gray",
                      onClick: (function (param) {
                          return Curry._1(onClose, undefined);
                        })
                    }), React.createElement(Form_Button$RecountTools.make, {
                      label: "Submit",
                      disabled: form.submitting,
                      kind: "submit",
                      className: "is-link"
                    }))
          }));
  return React.createElement(Modal$RecountTools.make, {
              isActive: isOpen,
              children: modalBody,
              onModalClose: (function (param) {
                  return Curry._1(onClose, undefined);
                })
            });
}

var make = Page_Sections_AddForm;

export {
  AddSectionForm ,
  make ,
  
}
/* react Not a pure module */
